module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hover-button",
    class: _vm.clazz,
    style: ({
      'transition-duration': _vm.duration + 's',
      '-moz-transition-duration': _vm.duration + 's',
      '-webkit-transition-duration': _vm.duration + 's',
      '-o-transition-duration': _vm.duration + 's'
    })
  }, [_c('div', {
    staticClass: "circle-outside",
    style: ({
      'transition-duration': _vm.duration + 's',
      '-moz-transition-duration': _vm.duration + 's',
      '-webkit-transition-duration': _vm.duration + 's',
      '-o-transition-duration': _vm.duration + 's'
    })
  }, [_c('div', {
    staticClass: "circle-inside",
    style: ({
      'transition-duration': _vm.duration + 's',
      '-moz-transition-duration': _vm.duration + 's',
      '-webkit-transition-duration': _vm.duration + 's',
      '-o-transition-duration': _vm.duration + 's'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "button-text",
    style: ({
      'transition-duration': _vm.duration + 's',
      '-moz-transition-duration': _vm.duration + 's',
      '-webkit-transition-duration': _vm.duration + 's',
      '-o-transition-duration': _vm.duration + 's'
    })
  }, [_vm._v(_vm._s(this.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b04de120"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/hoverButton.vue
// module id = 371
// module chunks = 12